const safeNumber = (value: unknown) => (Number.isNaN(Number(value)) ? 0 : Number(value));

export default safeNumber;
